import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react';
import TemplateDefault from "../../components/template-default";
import Card from "../../components/card";
import {AgGridReact} from "ag-grid-react";
import {LocalizationAgGrid} from "../../utils/localization-ag-grid";
import {useNavigate, useSearchParams} from "react-router-dom";
import Button from "../../components/button";
import {FaPlusSquare} from "react-icons/fa";
import InputForm from "../../components/input-form";
import {useQuery} from "@tanstack/react-query";
import activityControlService from "../../services/activity-control-service";
import TruncateCellRenderer from "../../components/cell-renderer/truncate-cell-renderer";
import general from "../../utils/general";
import {buildAccentInsensitiveColDef, setAccentInsensitiveQuickFilter} from "../../utils/ag-grid-quick-filter";
const BASENAME = process.env.PUBLIC_URL;


const ActivityControl = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const gridRef = useRef();
    const [search, setSearch] = useState(searchParams.get("search") ?? "");
    const [isGridReady, setIsGridReady] = useState(false);

    const {isLoading, data: activity} =useQuery({
        queryKey: ["activity-control"],
        queryFn: () => activityControlService.list().then(({data}) => {
            return data;
        }),
    });

    const onCellClicked = (cell) => {
        window.open(`${BASENAME}/activity-control/form/${cell.data.id}`)
    };

    const [columnDefs] = useState([
        { field: "date", headerName: "Data", maxWidth: 100,
            comparator: (a, b, nodeA, nodeB, isInverted) => {
                return general.nullLastDateStringComparator(a, b, nodeA, nodeB, isInverted);
            }
        },
        { field: "name", headerName: "Usuário", width: 300, cellRenderer: TruncateCellRenderer},
        { field: "gitlab", headerName: "Issues", flex: 1, cellRenderer: TruncateCellRenderer },
        { field: "observation", headerName: "Observação", flex: 1, cellRenderer: TruncateCellRenderer },
        { field: "waiting", headerName: "Sem tarefa", cellClass: "justify-center waiting-cell", cellStyle: {cursor: "default"}, cellEditor: "agCheckboxCellEditor", width: 85},
    ]);

    const defaultColDef = useMemo(() => {
        return buildAccentInsensitiveColDef({resizable: false});
    }, []);

    const onFilterTextBoxChanged = useCallback(({target}) => {
        setSearch(target.value);
    }, []);

    useEffect(() => {
        setSearch(searchParams.get("search") ?? "");
    }, [searchParams]);

    useEffect(() => {
        if (!isGridReady) return;

        setAccentInsensitiveQuickFilter(gridRef, search);
    }, [activity, isGridReady, search]);

    return (
        <TemplateDefault title="Cadastro" isLoading={isLoading}>
            <Card>
                <div className="flex flex-col lg:grid grid-cols-1 gap-x-6 gap-y-4 lg:grid-cols-12">
                    <div className="col-span-12">
                        <div className="flex justify-between gap-4">
                            <Button col="col-span-2" onClick={() => navigate("/activity-control/form")}>
                                <FaPlusSquare /> Novo
                            </Button>
                            <InputForm id="search" label="Pesquisar" col="w-[calc(100%-60px)]" type="search"
                                       value={search}
                                       onChange={onFilterTextBoxChanged} />
                        </div>
                    </div>
                </div>
                <div className={"ag-theme-quartz grid mt-4"} style={{ height: "calc(100vh - 165px)" }}>
                    <AgGridReact
                        ref={gridRef}
                        rowHeight={32}
                        rowData={activity}
                        columnDefs={columnDefs}
                        defaultColDef={defaultColDef}
                        pagination
                        paginationPageSize={500}
                        paginationPageSizeSelector={[100, 200, 300, 400, 500]}
                        animateRows={false}
                        suppressRowClickSelection={true}
                        suppressCellFocus={true}
                        onCellClicked={onCellClicked}
                        onGridReady={() => setIsGridReady(true)}
                        gridOptions={{ localeText: LocalizationAgGrid }}
                    />
                </div>
            </Card>
        </TemplateDefault>
    );
};

export default ActivityControl;
